import {
  Stack,
} from "@mui/material";
import Title from "../components/ui/Title";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import MarkChatUnreadIcon from "@mui/icons-material/MarkChatUnread";
import styled, { css } from "styled-components";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "../components/ui/Card";
import { StyledButton } from "../components/ui/StyledButton";
import { getAllTicket, fetchTicketCategory, CloseTicketByAdmin, CloseTicketData } from "../config/api";
import { CustomDataTable } from "../components/ui/uiImport";
import { GridRowModel } from "@mui/x-data-grid";
import toast from "react-hot-toast";
import ViewRemark from "../components/modals/ViewRemark";

interface TicketCategoyrData {
  id: number;
  category: string;
}

const SupportWeb = () => {
  const [sync, setSync] = useState(false);
  const [ticketCategory, setTicketCategory] = useState<TicketCategoyrData[]>([])
  console.log(ticketCategory);

  const TicketColumns = [
    {
      field: "awb_shipment_id",
      headerName: "Awb No",
      minWidth: 140,
      flex: 1,
      renderCell: (params: { row: GridRowModel }) => (
        <Stack direction={"column"}>
          {
            params.row.awb_shipment_id.map((data: any, index: number) => {
              return (
                <div key={index}>{data.guid}</div>
              )
            })
          }
        </Stack>
      ),
    },
    {
      field: "category",
      headerName: "Category",
      minWidth: 150,
      flex: 1,
      renderCell: (params: { row: GridRowModel }) => (
        <div>
          {ticketCategory.find((cat) => cat.id === params.row.category)?.category || "Unknown Category"}
        </div>
      ),
    },
    {
      field: "query_remark",
      headerName: "Remark",
      minWidth: 100,
      flex: 1,
      renderCell: (params: { row: GridRowModel }) => (
        <div className="custom-row-height">
          <ViewRemark value={params.row.query_remark} />
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 130,
      flex: 1,
      renderCell: (params: { row: GridRowModel }) => (
        <div style={{ minWidth: 100 }}>
          {params.row.status === 'active' ? (
            <div style={{ backgroundColor: '#b8b8b8', color: 'black', padding: '4px', borderRadius: '4px', textAlign: 'center' }}>
              Active
            </div>
          ) : (
            <div style={{ backgroundColor: 'green', color: 'white', padding: '4px', borderRadius: '4px', textAlign: 'center' }}>
              Closed
            </div>
          )}
        </div>
      ),
    },
    {
      field: "close_ticket",
      headerName: "Close Ticket",
      minWidth: 140,
      flex: 1,
      renderCell: (params: { row: any }) => (
        <>
          <ViewDetails ticket_id={params.row.id} status={params.row.status} />
        </>
      ),
    },
  ]

  const ViewDetails = ({ ticket_id, status }: { ticket_id: string, status: string }) => {
    return (
      <>
        <StyledButton
          onClick={() => CloseTicket(ticket_id)}
          sx={{
            textTransform: "none",
          }}
          variant="contained"

          disabled={status !== 'active'}

        >
          Close Ticket
        </StyledButton >
      </>
    )
  };

  function CloseTicket(ticket_id: any) {
    const CloseData = {
      query_id: ticket_id,
      status: "close"
    };

    CloseTicketByAdmin(CloseData).then((data) => {
      toast.success("Ticket Close.");
      setSync(true)
    }).catch((error) => {
      console.log(error);
    })
  }


  const [tableData, setTableData] = useState<any>([]);
  const [activeBox, setactiveBox] = useState<"ticket" | "help">("ticket");
  const navigate = useNavigate()

  useEffect(() => {
    getAllTicket().then((data) => {
      setTableData(data.data.data);
    }).catch((error) => {
      console.log(error);
    })

    fetchTicketCategory().then((data) => {
      setTicketCategory(data.data.data)
    }).catch((error) => {
      console.log();
    })

  }, [sync])

  const [page, setPage] = useState(1);

  const updatePage = (event: React.ChangeEvent<unknown>, page: number) => {
    event.preventDefault();
    setPage(page);
  };

  return (
    <>
      <Title title="Support - Web" />
      <p>Get help by creating a ticket or reading help articles</p>
      <Stack direction={{ xs: "column", sm: "row" }} gap={2} sx={{ pb: "25px" }}>
        <StyleHeader
          onClick={() => setactiveBox("ticket")}
          active={activeBox === "ticket"}
        >
          <Stack direction="row" gap={2}>
            <ConfirmationNumberIcon sx={{ color: "red" }} />
            Tickets
          </Stack>
        </StyleHeader>

        <StyleHeader
          onClick={() => setactiveBox("help")}
          active={activeBox === "help"}
        >
          <Stack direction="row" gap={2}>
            <MarkChatUnreadIcon color="success" />
            Help
          </Stack>
        </StyleHeader>
      </Stack>
      {activeBox === "ticket" && (
        <Card>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            marginBottom={"40px"}
          >

            <Title title="Tickets" />

            <StyledButton
              variant="contained"
              sx={{
                textTransform: "none",
              }}
              onClick={() =>
                navigate(`/support-and-help/ticket`)
              }
            >
              Create Ticket
            </StyledButton>
          </Stack>

          <CustomDataTable
            total={tableData.length}
            totalRow={tableData.page_count}
            rows={tableData}
            columns={TicketColumns}
            updatePage={updatePage}
            page={page}
          />

        </Card>
      )}

      {activeBox === "help" && <StyleOrder>Help Article</StyleOrder>}
    </>
  );
};

interface StyleHeaderProps {
  active?: true | false;
}

const StyleHeader = styled.div<StyleHeaderProps>`
  width: auto;
  border-radius: 10px;
  border: 1px solid black;
  background-color: #fff;
  padding: 20px;
  margin-top: 12px;
  cursor: pointer;
  ${(props) =>
    props.active === true &&
    css`
      border: 2px solid;
      border-color: #6149cd;
      box-shadow: 1px 2px 7px 0px rgba(0, 0, 0, 0.2);
    `}
`;

const StyleOrder = styled.div`
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    margin-top: 13px;
    box-shadow: 1px 2px 7px 0px rgba(0, 0, 0, 0.05);
    `;

export default SupportWeb;
